var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 21,
    viewBox: "0 0 64 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1_833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_833",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.169983H20V20.17H0V0.169983Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.169983V20.17M17.07 3.09898L2.928 17.241M20 10.17H0M17.07 17.241L2.928 3.09898",
    stroke: "#18181B",
    strokeWidth: 1.5
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1_833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1_833)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1_833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_833",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 20,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0.169983H64V20.17H44V0.169983Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 0.169983V20.17M61.07 3.09898L46.928 17.241M64 10.17H44M61.07 17.241L46.928 3.09898M57.824 19.409L50.171 0.929983M63.242 13.997L44.765 6.34298M44.762 13.997L63.239 6.34298M50.176 19.409L57.829 0.929983",
    stroke: "#18181B",
    strokeWidth: 1.5
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    fill: "white",
    transform: "translate(0 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(44 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(44 0.169983)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(44 0.169983)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/Container.e3ae51a49492156985668ab9e69e8564.svg";
export { ForwardRef as ReactComponent };